import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faYoutube,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faHeart, faBowlFood, faBuildingColumns, faArrowRight, faQuoteLeft, faHandHoldingHeart, faStethoscope, faGraduationCap, faHeartPulse } from "@fortawesome/free-solid-svg-icons";

// New high-quality assets
import heroImg from "../assets/redesign/happy_kids_charity_hero_1773041326964.png";
import nutritionIcon from "../assets/redesign/child_nutrition_icon_1773041352977.png";
import medicalIcon from "../assets/redesign/medical_heart_icon_1773041369100.png";
import facilitiesIcon from "../assets/redesign/school_facilities_icon_1773041384132.png";

// slider images
import slide1 from "../assets/redesign/slide1.png";
import slide2 from "../assets/redesign/slide2.png";
import slide3 from "../assets/redesign/slide3.png";

import ArticalImg1 from "../assets/articals/WhatsApp Image 2026-03-25 at 6.50.44 PM.jpeg";
import ArticalImg2 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.10 PM.jpeg";
import ArticalImg3 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.10 PM (1).jpeg";
import ArticalImg4 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.10 PM (2).jpeg";
import ArticalImg5 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.52 PM.jpeg";
import ArticalImg6 from "../assets/articals/WhatsApp Image 2026-03-25 at 7.36.52 PM (1).jpeg";

import kidImg1 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 6.50.45 PM (1).jpeg";
import kidImg2 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 6.50.45 PM (2).jpeg";
import kidImg3 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 6.50.45 PM.jpeg";
import kidImg4 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 7.36.09 PM.jpeg";
import kidImg5 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 7.36.11 PM (1).jpeg";
import kidImg6 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 7.36.11 PM.jpeg";
import kidImg7 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 7.36.40 PM.jpeg";
import kidImg8 from "../assets/ourkids/WhatsApp Image 2026-03-25 at 7.38.23 PM (1).jpeg";

const HOME_KIDS = [kidImg1, kidImg2, kidImg3, kidImg4, kidImg5, kidImg6, kidImg7, kidImg8];

const HERO_SLIDES = [
  {
    image: slide1,
    text: "Every child deserves access to quality medical expertise and lifesaving procedures."
  },
  {
    image: slide2,
    text: "Congenital heart disease can be fixed with early intervention."
  },
  {
    image: slide3,
    text: "No child should be devoid of treatment due to lack of economic support"
  }
];

const PILLARS = [
  {
    id: "nutrition",
    title: "ACCESSABLE & AFFORDABLE ",
    subtitle: "Nutrition & Food Aid",
    description: "Providing healthy, balanced meals to children who lack access to basic nutrition.",
    icon: nutritionIcon,
    accent: "bg-brand-gold",
    impact: "Nutritional Support",
  },
  {
    id: "medical",
    title: "REACHING THE UNREACHED ",
    subtitle: "Surgical & Medical Care",
    description: "Funding life-saving heart operations and providing essential medical support.",
    icon: medicalIcon,
    accent: "bg-brand-red",
    impact: "Life-saving Aid",
  },

];

const IMPACT_STATS = [
  { value: "50,000+", label: "Meals Served", icon: faBowlFood },
  { value: "500+", label: "Surgeries Funded", icon: faHeart },
  { value: "25+", label: "Centers Supported", icon: faBuildingColumns },
];

const DONATION_OPTS = [
  { amount: "Food", label: "Nutritious Food for Children", icon: faBowlFood },
  { amount: "Medical", label: "Medical Kit & Health Checkup", icon: faStethoscope },
  { amount: "Resource", label: "Educational Resource Support", icon: faGraduationCap },
  { amount: "Custom", label: "Support Life-saving Operations", icon: faHandHoldingHeart },
];

function Home() {
  const [hoveredPillar, setHoveredPillar] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen bg-brand-beige overflow-hidden font-sans">
      {/* Dynamic Hero Section */}
      <section className="relative min-h-[95vh] flex items-center justify-center overflow-hidden">
        {/* Slider Background Images */}
        {HERO_SLIDES.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 z-0 transition-opacity duration-1000 ease-in-out ${index === currentSlide ? "opacity-100" : "opacity-0"
              }`}
          >
            <img
              src={slide.image}
              alt={`Slide ${index + 1}`}
              className={`w-full h-full object-cover transition-transform duration-[10s] ease-out ${index === currentSlide ? "scale-100" : "scale-110"
                }`}
            />
            <div className="absolute inset-0 bg-black/50" />
          </div>
        ))}

        {/* Hero Content */}
        <div className="container mx-auto px-6 relative z-10 text-center text-white py-12">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-[26px] md:text-[42px] font-bold mb-4 tracking-tighter drop-shadow-2xl leading-tight min-h-[1.2em] transition-all duration-700">
              {HERO_SLIDES[currentSlide].text.split(' ').map((word, i) => (
                <span key={i} className={word.toLowerCase() === 'medical' || word.toLowerCase() === 'heart' || word.toLowerCase() === 'treatment' || word.toLowerCase() === 'economic' ? "text-brand-red italic" : ""}>
                  {word}{' '}
                </span>
              ))}
            </h1>
            <p className="text-[10px] md:text-[20px] mb-6 max-w-3xl mx-auto opacity-90 leading-relaxed font-light drop-shadow-md">
              Let's Reach The Unreached. <br />
              Ensuring every child born with a Congenital Heart Defect has a chance to live a healthy life.</p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/donate-now"
                className="px-6 py-2 gradient-bg text-white rounded-full font-bold text-[18px] hover-scale hover-glow transition-all shadow-xl flex items-center gap-2"
              >
                Donate Now <FontAwesomeIcon icon={faHeart} className="animate-pulse" />
              </Link>
              <Link
                to="/aboutus"
                className="px-6 py-2 bg-brand-gold text-white rounded-full font-bold text-[18px] hover:bg-brand-gold/90 transition-all border border-brand-gold shadow-lg"
              >
                See Our Mission
              </Link>
            </div>
          </div>

          {/* Slider Indicators */}
          <div className="flex justify-center gap-2 mt-6">
            {HERO_SLIDES.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentSlide ? "bg-brand-red w-6" : "bg-white/50"
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Hero Bottom - Scrolling Marquee */}
        <div className="absolute bottom-0 w-full glass py-4 border-t border-white/20 z-20">
          <div className="marquee">
            <span className="marquee__content text-slate-900 font-bold text-sm">
              • 100% OF DONATIONS GO TO TREATMENT • 80G TAX BENEFIT • REGISTERED TRUST • HELPING KIDS 0-18 YEARS • NGO FOR CHILDREN • OVER 500 SURGERIES COMPLETED • QUALITY HEALTHCARE •
            </span>
            <span className="marquee__content text-slate-900 font-bold text-sm">
              • 100% OF DONATIONS GO TO TREATMENT • 80G TAX BENEFIT • REGISTERED TRUST • HELPING KIDS 0-18 YEARS • NGO FOR CHILDREN • OVER 500 SURGERIES COMPLETED • QUALITY HEALTHCARE •
            </span>
          </div>
        </div>
      </section>

      {/* The Three Pillars Section */}
      <section className="py-32 bg-white relative overflow-hidden" id="pillars">
        <div className="absolute top-1/4 -left-20 w-[500px] h-[500px] bg-brand-beige rounded-full blur-[120px] opacity-40" />
        <div className="absolute bottom-1/4 -right-20 w-[500px] h-[500px] bg-brand-beige rounded-full blur-[120px] opacity-40" />

        <div className="container mx-auto px-6 relative">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-black text-slate-900 mb-6 tracking-tight">SAVE A  <span className="gradient-text">LITTLE HEART </span></h2>
            <p className="text-slate-500 max-w-2xl mx-auto text-xl font-light">
              We bridge the gap for low-income families, ensuring no child suffers FROM CONGENITAL HEART DISEASE due to lack of funds.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {PILLARS.map((pillar) => (
              <div
                key={pillar.id}
                className="group relative"
                onMouseEnter={() => setHoveredPillar(pillar.id)}
                onMouseLeave={() => setHoveredPillar(null)}
              >
                <div className="glass-card h-full flex flex-col items-center text-center p-10 group-hover:bg-white transition-all transform group-hover:-translate-y-4">
                  <div className={`w-40 h-40 mb-8 p-3 rounded-[2.5rem] ${pillar.accent} shadow-2xl rotate-3 group-hover:rotate-0 transition-transform`}>
                    <div className="bg-white rounded-[2rem] w-full h-full flex items-center justify-center overflow-hidden">
                      <img src={pillar.icon} alt={pillar.title} className="w-full h-full object-cover p-2 scale-110 group-hover:scale-125 transition-transform" />
                    </div>
                  </div>
                  <h3 className="text-3xl font-black text-slate-900 mb-2 tracking-tight">{pillar.title}</h3>
                  <h4 className="text-lg font-bold text-brand-red mb-6 uppercase tracking-wider">{pillar.subtitle}</h4>
                  <p className="text-slate-500 text-lg mb-10 leading-relaxed italic">"{pillar.description}"</p>
                  <Link to="/donate-now" className="w-full py-4 glass border-2 border-brand-gold/10 text-slate-800 font-black rounded-2xl  transition-all shadow-lg uppercase tracking-tighter">
                    Support {pillar.title}
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Interactive Impact Section */}
      <section className="py-32 bg-brand-beige">
        <div className="container mx-auto px-6">
          <div className="glass-card p-16 border-none shadow-[0_50px_100px_-20px_rgba(0,0,0,0.1)] relative overflow-hidden flex flex-col lg:flex-row items-center justify-between gap-16">
            <div className="lg:max-w-2xl text-left">
              <h2 className="text-5xl font-black text-slate-900 mb-8 leading-tight">Every Second <br /><span className="gradient-text italic">Counts for a Heart.</span></h2>
              <p className="text-slate-600 mb-12 text-xl font-light leading-relaxed">
                Congenital Heart Defects (CHD) are the most common birth defects.
                With your donation, we provide 100% financial support for surgeries, post-op care, and follow-ups.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {DONATION_OPTS.map((opt, i) => (
                  <Link to="/donate-now" key={i} className="flex items-center gap-5 p-5 rounded-3xl bg-white shadow-xl hover:shadow-2xl hover:scale-105 transition-all group border border-brand-beige">
                    <div className="w-16 h-16 rounded-2xl gradient-bg flex items-center justify-center text-white text-2xl shadow-lg shrink-0">
                      <FontAwesomeIcon icon={opt.icon} />
                    </div>
                    <div>
                      <div className="font-black text-2xl text-slate-900 tracking-tighter">{opt.amount}</div>
                      <div className="text-sm text-slate-500 font-bold">{opt.label}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            <div className="flex flex-col gap-8 w-full max-w-md">
              {IMPACT_STATS.map((stat, i) => (
                <div key={i} className="p-8 glass bg-white flex items-center gap-8 rounded-[3rem] hover:translate-x-4 transition-transform border-none shadow-xl">
                  <div className="w-20 h-20 rounded-3xl bg-red-900 flex items-center justify-center text-white text-3xl shadow-2xl">
                    <FontAwesomeIcon icon={stat.icon} />
                  </div>
                  <div>
                    <div className="text-4xl font-black text-slate-900 tracking-tighter">{stat.value}</div>
                    <div className="text-brand-red font-black uppercase tracking-widest text-xs">{stat.label}</div>
                  </div>
                </div>
              ))}
              <Link to="/donate-now" className="mt-4 p-6 rounded-[2rem] gradient-bg text-white text-center font-black text-2xl shadow-2xl hover-glow hover:scale-110 transition-all uppercase tracking-tighter">
                Give Hope Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Articles Section */}
      <section className="py-24 bg-brand-red/5">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-12 tracking-tight uppercase">
            In The <span className="text-brand-red">News</span>
          </h2>
          <div className="max-w-6xl mx-auto px-4 md:px-12">
            <Slider
              dots={true}
              infinite={true}
              speed={500}
              slidesToShow={3}
              slidesToScroll={1}
              autoplay={true}
              autoplaySpeed={3000}
              pauseOnHover={true}
              responsive={[
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 640,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
              ]}
              className="articles-slider"
            >
              {[ArticalImg1, ArticalImg2, ArticalImg3, ArticalImg4, ArticalImg5, ArticalImg6].map((img, index) => (
                <div key={index} className="px-3 py-4">
                  <div
                    className="rounded-2xl overflow-hidden shadow-lg border-4 border-white h-96 bg-white relative group cursor-pointer transform hover:-translate-y-2 transition-all duration-300"
                    onClick={() => window.open(img, '_blank')}
                  >
                    <img
                      src={img}
                      alt={`News Article ${index + 1}`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-brand-red/10 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-[2px]">
                      <span className="bg-white text-brand-red px-6 py-3 rounded-full font-black text-sm shadow-2xl tracking-wide uppercase">
                        View Article
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* Our Kids Section (Preview) */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-black mb-12 tracking-tighter uppercase">Our <span className="text-brand-red italic">Brave Hearts</span></h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12">
            {HOME_KIDS.map((kidImg, i) => (
              <div key={i} className="group cursor-pointer">
                <div className="relative overflow-hidden rounded-[2rem] shadow-xl aspect-[4/5] bg-slate-900 transform hover:-translate-y-2 transition-all duration-500">
                  <img
                    src={kidImg}
                    alt={`Super Kid ${i + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 opacity-90 group-hover:opacity-100"
                  />
                  {/* Overlay on hover */}
                  <div className="absolute inset-0 bg-brand-red/80 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center p-6 text-center text-white">
                    <div className="relative z-10">
                      <FontAwesomeIcon icon={faHeartPulse} size="2x" className="mb-3 animate-pulse" />
                      <p className="font-black text-xl uppercase tracking-tighter leading-none">Healthy Heart</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <Link to="/our-kids" className="inline-block px-10 py-4 border-2 border-brand-red text-brand-red rounded-full font-black text-lg hover:bg-brand-red hover:text-white transform transition-all shadow-lg uppercase tracking-wider">
            View All Kids
          </Link>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-40 bg-slate-900 text-white text-center relative">
        <div className="container mx-auto px-6 relative z-10">
          <FontAwesomeIcon icon={faQuoteLeft} className="text-8xl text-brand-red mb-12" />
          <h2 className="text-4xl md:text-7xl font-black mb-12 max-w-5xl mx-auto leading-[1.1] tracking-tighter italic">
            "Ensuring no child dies of a Congenital Heart Defect due to a <span className="text-brand-red">lack of funds.</span>"
          </h2>
          <div className="w-24 h-2 gradient-bg mx-auto rounded-full mb-8 shadow-2xl" />
          <p className="text-2xl font-black uppercase tracking-[0.3em] text-brand-red opacity-80">Our Sole Mission</p>
        </div>
      </section>
    </div>
  );
}

export default Home;
